import React from 'react'
import PhotoUpload from './PhotoUpload/PhotoUpload'
import ResponseLoadingScreen from '../ResponseLoadingScreen/ResponseLoadingScreen'
import {ErrorPopup} from '../ErrorPopup/ErrorPopup'
import Axios from 'axios'
import './add-teacher-modal.css'
import { baseUrl } from '../assets/Animations'
import AddInstrumentPopup from './AddInstrumentsPopup/AddInstrumentsPopup'
import AddTownsPopup from './AddTownsPopup/AddTownsPopup'

const AddTeacherModal = (props) => {
    const [modal, setModal] = React.useState(false)
    const [img, setImg] = React.useState(false)
    const [imageName, setImageName] = React.useState('')
    const [error, setError] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [required, setRequired] = React.useState({name: false, email: false, instrument: false, school: false, rate: false, bio: false})
    const [instPopup, setInstPopup] = React.useState(false)
    const [townsPopup, setTownsPopup] = React.useState(false)
    const [listOfInstruments, setListOfInstruments] = React.useState([])
    const [listOfTowns, setListOfTowns] = React.useState([])

    React.useEffect(() => {

    }, [required])

    const closeModal = (target) => {
        if(target === "add-teacher-modal-wrapper") {
            props.setAddTeacherModal(false)
            setImg(false)
        }
    }

    const toggleUploadModal = () => {
        if(modal === false) {
            setModal(true)
        } else {
            setModal(false)
        }
    }

    const removeTheRed = (id, value, inputName) => {
        const updatedRequired = required
        if(value === '') {
            document.getElementById(id).style.border = "1px solid orange"
            updatedRequired[inputName] = false
            setRequired(updatedRequired)
        } else {
            document.getElementById(id).style.border = "1px solid black"
            updatedRequired[inputName] = true
            setRequired(updatedRequired)
            if(required.name && required.email && required.school && required.rate && required.bio) {
                document.getElementById("add-teacher-modal-submit-btn").style.border = "1px solid green"
                document.getElementById("add-teacher-modal-submit-btn").style.color = "green"
                document.getElementById("add-teacher-modal-submit-btn").style.cursor = "pointer"
            } else {
                document.getElementById("add-teacher-modal-submit-btn").style.border = "1px solid rgb(139, 139, 139)"
                document.getElementById("add-teacher-modal-submit-btn").style.color = "rgb(139, 139, 139)"
                document.getElementById("add-teacher-modal-submit-btn").style.cursor = "default"
            }
        }
    }

    const submitNewTeacher = (e) => {
        let rawEmail = document.getElementById("new-teacher-form-teacher-email").value
        let lowerCaseEmail = rawEmail.toLowerCase()
        let finalEmail = lowerCaseEmail.replace(/\s/g,'')
        e.preventDefault()
        const form = {}
        form.name = document.getElementById("new-teacher-form-teacher-name").value
        form.email = finalEmail.toLowerCase()
        form.imageName = imageName
        form.phone = document.getElementById("new-teacher-form-teacher-phone-number").value
        // form.instrument = document.getElementById("new-teacher-form-teacher-instrument").value
        form.calendarId = document.getElementById("new-teacher-form-teacher-calendar-id").value
        form.street = document.getElementById("new-teacher-form-teacher-street").value
        form.city = document.getElementById("new-teacher-form-teacher-city").value
        form.state = document.getElementById("new-teacher-form-teacher-state").value
        form.zip = document.getElementById("new-teacher-form-teacher-zip").value
        form.school = document.getElementById("new-teacher-form-teacher-school").value
        form.bio = document.getElementById("new-teacher-form-teacher-bio").value
        form.rate = document.getElementById("new-teacher-form-teacher-rate").value
        if(required.name && required.email && required.school && required.rate && required.bio) {
            setLoading(true)
            Axios.post(`${baseUrl}/register`, {
                TeacherID: Math.random().toString(16).slice(2),
                Name: form.name,
                Email: form.email,
                Instrument: '',
                InstrumentList: listOfInstruments,
                TownList: listOfTowns,
                CalendarID: form.calendarId,
                ImageName: form.imageName,
                Bio: form.bio,
                Address: {
                    StreetAddress: form.street,
                    City: form.city,
                    State: form.state,
                    Zip: form.zip
                },
                PhoneNumber: form.phone,
                School: form.school,
                Rate: form.rate,
                OnboardDate: Date()
            })
            .then(response => {
                if(response.status === 201) {
                    setLoading(false)
                    props.closeModal(response.data)
                } else {
                    console.log(response)
                    console.log(response.message)
                    //console.log(response.data.message)
                    setLoading(false)
                    setError(true)
                }
            })
            .catch(err => {
                console.log(err)
                console.log(err.message)
                console.log(err.response)
                console.log(err.response.data)
                //console.log(err.data.message)
                setLoading(false)
                setError({message: err.response.data, status: err.response.status})
            })
        } else {
            alert('Please enter all required fields. Thank you!')
        }
    }
    return(
        <>
        {props.open && 
            <div className="add-teacher-modal-wrapper" id="add-teacher-modal-wrapper" onClick={(e) => closeModal(e.target.id)}>
                <ResponseLoadingScreen loading={loading} />
                {error && <ErrorPopup error={error} setError={setError} />}
                <PhotoUpload modal={modal} setImg={setImg} toggleUploadModal={toggleUploadModal} setImageName={setImageName}/>
                {instPopup && <AddInstrumentPopup setInstPopup={setInstPopup} listOfInstruments={listOfInstruments} setListOfInstruments={setListOfInstruments} />}
                {townsPopup && <AddTownsPopup setTownsPopup={setTownsPopup} listOfTowns={listOfTowns} setListOfTowns={setListOfTowns} school={document.getElementById("new-teacher-form-teacher-school").value}/>}
                <div className="add-teacher-modal-content">
                    <h2>Add New Teacher</h2>
                    <form onSubmit={(e) => submitNewTeacher(e)}>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Name</label>
                            <input type="text" className="new-teacher-form-required new-teacher-form-input" placeholder="Steve Harvey" id="new-teacher-form-teacher-name" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'name')} />
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Email</label>
                            <input type="text" className="new-teacher-form-required new-teacher-form-input" placeholder="steve@harvey.com" id="new-teacher-form-teacher-email" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'email')} />
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Phone Number</label>
                            <input type="text" className="new-teacher-form-input" placeholder="XXX-XXX-XXXX" id="new-teacher-form-teacher-phone-number"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Instrument(s)</label>
                            <div className='new-teacher__add-instuments' onClick={() => setInstPopup([])}>+</div>
                            {/* <input type="text" className="new-teacher-form-required new-teacher-form-input" placeholder="Piano - Voice" id="new-teacher-form-teacher-instrument" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'instrument')} /> */}
                            {listOfInstruments.map((inst) => <p key={inst.id} className='list-of-instrument-new-teacher'>{inst.name}</p>)}
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Calendar Id</label>
                            <input type="text" className="new-teacher-form-input" placeholder="abcdef@group.calendar" id="new-teacher-form-teacher-calendar-id"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Street</label>
                            <input type="text" className="new-teacher-form-input" placeholder="123 Main St Apt #5" id="new-teacher-form-teacher-street"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">City</label>
                            <input type="text" className="new-teacher-form-input" placeholder="Place" id="new-teacher-form-teacher-city"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">State</label>
                            <input type="text" className="new-teacher-form-input" placeholder="CO" id="new-teacher-form-teacher-state"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Zip Code</label>
                            <input type="text" className="new-teacher-form-input" placeholder="12345" id="new-teacher-form-teacher-zip"/>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">School</label>
                            <select name="School" className="add-teacher-school-select new-teacher-form-required new-teacher-form-input" id="new-teacher-form-teacher-school" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'school')} >
                                <option default value="">Select a school...</option>
                                <option value="mma">Mountainside</option>
                                <option value="lsma">Lakeside</option>
                                <option value="tma">Treeside</option>
                                <option value="mor">Morningside</option>
                                <option value="psma">Parkside</option>
                                <option value="tem">Tempe</option>
                                <option value="den">Denton</option>
                                <option value="tul">Tulsa</option>
                            </select>
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Rate (No $)</label>
                            <input type="text" className="new-teacher-form-required new-teacher-form-input" placeholder="35" id="new-teacher-form-teacher-rate" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'rate')} />
                        </div>
                        <div className="add-teacher-input-wrapper">
                            <label className="add-teacher-label">Towns(s)</label>
                            <div className='new-teacher__add-instuments' onClick={() => setTownsPopup([])}>+</div>
                            {/* <input type="text" className="new-teacher-form-required new-teacher-form-input" placeholder="Piano - Voice" id="new-teacher-form-teacher-instrument" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'instrument')} /> */}
                            {listOfTowns.map((town) => <p key={town.id} className='list-of-instrument-new-teacher'>{town.townName}</p>)}
                        </div>
                        <div className="add-teacher-input-bio-wrapper">
                            <label className="add-teacher-label">Bio</label>
                            <p className="add-teacher-subtext">*Please remove all "returns"</p>
                            <textarea className="add-teacher-bio new-teacher-form-required" type="text" placeholder="Bio..." id="new-teacher-form-teacher-bio" onChange={(e) => removeTheRed(e.target.id, e.target.value, 'bio')} />
                        </div>
                        {img ? 
                            <div style={{backgroundImage: `url(${img})`}} className="img-preview "></div>
                            :
                            <div className="add-teacher-input-wrapper teacher-image-button" onClick={() => toggleUploadModal()}>
                                Upload Picture
                            </div>   
                        }
                        <div>
                            <input className="add-teacher-modal-submit-btn" id="add-teacher-modal-submit-btn" type="submit" value="Submit"></input>
                        </div>
                    </form>
                </div>
            </div>
        }
        </>
    )
}

export default AddTeacherModal